'use client'
import { getSectionLink } from './getSectionLink'

export const getPageSection = () => {
  return getSectionLink(window?.location.pathname)
}
